module.exports = __webpack_public_path__ + "media/images/vedett_allatok/vedett6-379754a39cc7bd5d2f4852a16416ee47.jpg";